import { QuestionCircleOutlined } from '@ant-design/icons';
import { typographyStyle, Colors, Flex } from '@revenuemarket/cds';
import { Switch, Tooltip, Typography } from 'antd';

import InfoItem from '../../InfoItem';

interface Props {
  isActive: boolean;
  onToggle: (checked: boolean) => void;
}

const ActiveToggleSection: React.FC<Props> = ({ isActive, onToggle }) => {
  return (
    <InfoItem
      title={
        <Flex align="center" gap={4}>
          <Typography.Text style={{ ...typographyStyle['14_400'], color: Colors.gray600 }}>
            활성
          </Typography.Text>
          <Tooltip
            title={
              <>
                비활성 하면 이 계정을 선택할 수 없고,
                <br /> 자동화 대상에서 제외돼요.
                <br />
                하위 계정은 비활성 되지 않아요.
              </>
            }
          >
            <QuestionCircleOutlined
              width={18}
              height={18}
              style={{
                color: Colors.gray600,
              }}
            />
          </Tooltip>
        </Flex>
      }
      description={
        <Switch
          checked={isActive}
          onChange={async (checked) => {
            onToggle(checked);
          }}
        />
      }
    />
  );
};

export default ActiveToggleSection;
